import "./FireIcon.scss"

export default function FireIcon() {
  return (
    <span className='fire-icon' />
  )
}